export default __webpack_public_path__ + "resources/icons/d0-c20c.png";